import { render, staticRenderFns } from "./BaseConfirm.vue?vue&type=template&id=5dfcfe10"
import script from "./BaseConfirm.vue?vue&type=script&lang=js"
export * from "./BaseConfirm.vue?vue&type=script&lang=js"
import style0 from "./BaseConfirm.vue?vue&type=style&index=0&id=5dfcfe10&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports